<template>
	<div id="app">
		<el-container>
			<el-header class="el-header" style="height: 80px;z-index: 999;">
				<Header></Header>
			</el-header>
			<el-main class="el-main" style="z-index: 1;">
				<router-view></router-view>
			</el-main>
			<el-footer class="el-footer">
				<Footer></Footer>
			</el-footer>
		</el-container>
	</div>
</template>

<script>
	import Header from './components/public/Header.vue'
	import Footer from './components/public/Footer.vue'

	export default {
		name: 'App',
		components: {
			Header,
			Footer
		}
	}
</script>

<style>
	@font-face {
		font-family: 'Rany';
		src: url('./assets/font/Rany.ttf') format('truetype');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'Rany Light';
		src: url('./assets/font/Rany-Light.ttf');
		font-weight: 300;
		font-style: normal;
	}

	@font-face {
		font-family: 'Rany Bold';
		src: url('./assets/font/Rany-Bold.ttf') format('truetype');
		font-weight: normal;
		font-style: normal;
	}

	.poppins-regular {
		font-family: "Poppins", serif;
		font-weight: 400;
		font-style: normal;
	}

	.poppins-bold {
		font-family: "Poppins", serif;
		font-weight: 700;
		font-style: normal;
	}

	body {
		margin: 0;
		font-family: 'Noto Sans SC', 'Poppins', sans-serif;
	}

	.el-main {
		padding: 0 !important;
	}

	.el-header {
		padding: 0 !important;
	}

	.el-footer {
		padding: 0 !important;
	}

	.el-main::-webkit-scrollbar {
		width: 0;
	}
</style>
